import axiosInstance from '../axiosInterceptor/axiosInstance'

const changeCard = (data) => {
  const { orgId } = data
  const url = `v1/orgs/${orgId}/billing/card-verification`
  return axiosInstance.post(url, null)
}

export default changeCard
